import { Image, Modal, Text, VStack } from "native-base";
import React from "react";

import IfeiraLogo from "@/assets/icons/secondary_icon.png";
import { useViewport } from "@/contexts/ViewportContext";

type OrderCompletedModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const OrderCompletedModal = ({ isOpen, onClose }: OrderCompletedModalProps) => {
  const { isWebMode } = useViewport();
  const layoutProps = !isWebMode ? { h: "100%", marginBottom: 0, marginTop: "auto" } : { h: "30%" };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={isWebMode ? "xl" : "full"}
      animationPreset={isWebMode ? "fade" : "slide"}
      useRNModal
      avoidKeyboard>
      <Modal.Content bgColor="secondary.400" {...layoutProps}>
        <VStack flexGrow={1} justifyContent="center" alignItems="center">
          <Image source={IfeiraLogo} resizeMode="contain" w="120px" h="60px" alt="ifeira logo" />
          <Text fontSize="2xl" color="primary.600" textAlign="center" py="8" bold>
            Compra realizada com sucesso!
          </Text>
        </VStack>
      </Modal.Content>
    </Modal>
  );
};

export default OrderCompletedModal;
